import 'babel-polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import Lightbox from 'vue-easy-lightbox'
Vue.use(Lightbox)
import VueSimpleSVG from 'vue-simple-svg'
Vue.use(VueSimpleSVG)
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
Vue.use(VueVideoPlayer)

//window.$ = window.jQuery = require('jquery');
//require('jquery')
//require('jquery-confirm')

Vue.prototype.$eventBus = new Vue(); // Global event bus

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
